import axiosCall from './interceptor';
import URL from '../helper';
import { doesEmailExist } from 'supertokens-web-js/recipe/emailpassword';
import { message } from 'antd';
import i18n from '../../i18n';
import { SERVICE_MESSAGES } from '../translationValues';

i18n.loadNamespaces(['SERVICE_MESSAGES', 'API_ERROR_MESSAGES']);

//FIXME: Delete before pushing since not used anywhere
//Supertokens Email verification
// export const checkVerifyEmail = async () => {
//   const url = `${URL.AUTH_SERVICE_URL}user/email/verify`;
//   let response = await axiosCall('get', url);
//   return response.data;
// };

//API to carry out Email verification process in supertokens
export const verifyEmail = async data => {
  const url = `${URL.AUTH_SERVICE_URL}user/email/verifyDetails`;
  let response = await axiosCall('post', url, data,false);
  return response.data;
};

//Fetch stripe pricing plans
export const getPricingPlans = async () => {
  const url = `${URL.BASE_URL}pricingTable`;
  let response = await axiosCall('get', url);
  return response?.data?.data;
};

export const activateLicense = async newActivationKey => {
  const url = `${URL.BASE_URL}activatelicense`;
  const data = {
    licenseKey: newActivationKey,
  };
  const response = await axiosCall('post', url, data);
  return response.data;
};

export const emailExists = async email => {
  try {
    let response = await doesEmailExist({
      email,
    });
    // if (response.doesExist) {
    //   message.error('Email already exists. Please sign in instead');
    // }
    return response.doesExist;
  } catch (err) {
    if (err.isSuperTokensGeneralError === true) {
      // this may be a custom error message sent from the API by you.
      message.error(err.message);
    } else {
      message.error(i18n.t(`SERVICE_MESSAGES:${SERVICE_MESSAGES.GENERAL_OOPS_ERROR.key}`, SERVICE_MESSAGES.GENERAL_OOPS_ERROR.value));
    }
  }
};

// get plan details and email
export const getUserMail = async () => {
  const url = `${URL.AUTH_SERVICE_URL}user/meta`;
  const response = await axiosCall('get', url);
  return response.data;
};

//  create checkout session
export const createCheckout = async payload => {
  const url = `${URL.BASE_URL}createCheckout`;
  const response = await axiosCall('post', url, payload); 
  if (response.status === 200) {
    return response.data?.data;
  } else {
    message.error(response?.errors);
  }
};

// fetchUserDetails
export const fetchUserDetails = async payload => {
  const url = `${URL.BASE_URL}fetchUserDetails`;
  const response = await axiosCall('get', url);
  // console.log('response',response);
  // response.data.data.licenseType ="ENTERPRISE"
  return response.data;
};


// Verify password
export const VerifyPassword = async payload => {
  const url = `${URL.AUTH_SERVICE_URL}user/password/verify`;
  const response = await axiosCall('post', url,payload); 
  return response.data;
};


//  create customer portal
export const createCustomerPortal = async payload => {  
  const url = `${URL.BASE_URL}createCustomerSubscriptionPortal`;
  const response = await axiosCall('post', url); 
  if (response?.status === 200) {
    return response.data?.data;
  } else {
    message.error(response?.errors);
  }
};


// Verify password
export const updatePassword = async payload => {
  const url = `${URL.AUTH_SERVICE_URL}user/password/change`;
  const response = await axiosCall('post', url,payload); 
  return response.data;
};

// Fetch the API Key
export const fetchAPIKey = async (payload = {}) => {
  const params = new URLSearchParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}fetchAPIKey`;
  const response = await axiosCall('get', url, params); 
  return response.data;
};

// Regenerate the API Key
export const regenerateAPIKey = async (payload = {}) => {
  const params = new URLSearchParams(payload).toString();
  const url = `${URL.TRANSACTION_SYSTEM_URL}regenerateAPIKey`.concat(params ? `?${params}` : '');
  const response = await axiosCall('post', url, params); 
  return response.data;
};

// Disable the walkthrough using this API, so that it doesn't show for users who are not logging in for the first time.
export const firstLoginComplete = async () => {
  const url = `${URL.AUTH_SERVICE_URL}user/walkthrough`;
  const response = await axiosCall('post', url);
  return response.data;
};

export const fetchAllOrganizationDetails = async payload => {
  const params = new URLSearchParams(payload);
  let url = `${URL.BASE_URL}fetchAllOrganizationDetails`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getTrackingAccessToken = async payload => {
  const url = `${URL.TRACKING_SYSTEM_URL}getToken`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const ssoAuthenticate = async (token) => {
  const url = `${URL.AUTH_SERVICE_URL}authenticate?access_token=${token}`;
  const response = await axiosCall('post', url);
  return response.data;
}

export const embedAuthenticate = async (token) => {
  const url = `${URL.EMBED_AUTHENTICATE_URL}/authenticate?tempToken=${token}`;
  const response = await axiosCall('post', url);
  return response.data;
}

export const checkStorageStatus = async () => {
  const url = `${URL.BASE_URL}storage/status`;
  const response = await axiosCall('get', url);
  return response.data;
}

export const setStorageStatus = async (payload) => {
  const url = `${URL.BASE_URL}storage/status`;
  const response = await axiosCall('post', url, payload);
  return response.data;
}